import { render, staticRenderFns } from "./Dec.vue?vue&type=template&id=480e867e&"
import script from "./Dec.vue?vue&type=script&lang=js&"
export * from "./Dec.vue?vue&type=script&lang=js&"
import style0 from "./Dec.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports